import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { PVG_PORTAL_KEY } from './core/types/projeto.types';
import { PreparePortalComponent } from './prepare-portal.component';
import { ManutencaoComponent } from './manutencao/manutencao.component';
import { RuralOviAuthGuard } from './modules/map/guards/rural-ovi-auth.guard';

const isTopocartDev = environment['isTopocartDev'];

const baseRoutes: Routes = [
  { path: '', component: PreparePortalComponent },
  // { path: '', redirectTo: 'manutencao', pathMatch: 'full' },
  { path: 'manutencao', component: ManutencaoComponent },
  {
    path: 'sso/callback',
    loadComponent: () =>
      import(
        './goiania-sso/pages/goiania-sso-callback/goiania-sso-callback.component'
      ).then((m) => m.GoianiaSsoCallbackComponent),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'select-mode',
    loadChildren: () =>
      import('./modules/select-portal-mode/select-portal-mode.module').then(
        (m) => m.SelectPortalModeModule
      ),
  },
];

const topocartDevRoutes: Routes = isTopocartDev
  ? [
      {
        path: ':city/sso/callback',
        loadComponent: () =>
          import('./goiania-sso/pages/goiania-sso-callback/goiania-sso-callback.component').then(
            (m) => m.GoianiaSsoCallbackComponent
          ),
      },
      {
        path: ':city/auth',
        loadChildren: () =>
          import('./modules/auth/auth.module').then((m) => m.AuthModule),
      },
      {
        path: ':city',
        component: PreparePortalComponent,
      },
      {
        path: ':city/' + PVG_PORTAL_KEY,
        pathMatch: 'full' as const,
        redirectTo: ':city/' + PVG_PORTAL_KEY + '/map',
      },
      {
        path: ':city/ovi-rural',
        pathMatch: 'full' as const,
        redirectTo: ':city/ovi-rural/map',
      },
      {
        path: ':city/icad',
        pathMatch: 'full' as const,
        redirectTo: ':city/icad/map',
      },
      {
        path: ':city/:mode/map',
        canActivate: [RuralOviAuthGuard],
        loadChildren: () =>
          import('./modules/map/map.module').then((m) => m.MapModule),
      },
    ]
  : [];

const defaultRoutes: Routes = [
  {
    path: PVG_PORTAL_KEY,
    pathMatch: 'full' as const,
    redirectTo: PVG_PORTAL_KEY + '/map',
  },
  {
    path: 'ovi-rural',
    pathMatch: 'full' as const,
    redirectTo: 'ovi-rural/map',
  },
  { path: 'icad', pathMatch: 'full' as const, redirectTo: 'icad/map' },
  { path: 'simples', pathMatch: 'full' as const, redirectTo: 'simples/map' },
  {
    path: ':mode/map',
    canActivate: [RuralOviAuthGuard],
    loadChildren: () =>
      import('./modules/map/map.module').then((m) => m.MapModule),
  },
  {
    path: 'not-found/:city',
    loadChildren: () =>
      import('./modules/404/not-found.module').then((m) => m.NotFoundModule),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

const routes: Routes = [
  ...baseRoutes,
  ...topocartDevRoutes,
  ...defaultRoutes,
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
